import { useContext } from 'react';

import { ExperimentContext } from './ExperimentProvider';

export type Experiment =
  | 'Hide_Id'
  | 'Question_Section_Heading'
  | 'Custom_Questions'
  | 'Selection_Type_Toggle'
  | 'Show_Certsy_Verifiable'
  | 'Search_Survey'
  | 'Seek_Pass_Awareness_Top'
  | 'Seek_Pass_Awareness_Bottom'
  | 'Seek_Pass_Awareness_Control'
  | 'Search_Bar_Top'
  | 'Search_Bar_Bottom'
  | 'New_Save_Draft_API'
  | 'Filter_Awareness';

export const useExperiment = (experimentName: Experiment): boolean => {
  const experimentContext = useContext(ExperimentContext);
  return experimentContext.includes(experimentName);
};
